export default (urlParameters) => {
  return {
    allowedMapProducts: null,
    defaultMapProductSettings: null,
    mapProductIds: null,
    parameterIds: null
  }
}